// This file is used to require assets that the site needs. Webpack will use this file as the entry point.
require('./application.scss');

const req = require.context('./js', true, /\.js$/);
req.keys().forEach(req);